import { createFileRoute } from '@tanstack/react-router';
import { PublicTask } from '../../../features/tasks/PublicTask';
export const Route = createFileRoute('/_public/task/$token')({
  head: () => ({
    meta: [
      { name: 'robots', content: 'noindex, nofollow' },
      { name: 'referrer', content: 'no-referrer' },
    ],
  }),
  component: function PublicTaskRoute() {
    const { token } = Route.useParams();
    return <PublicTask token={token} />;
  },
});
